import { axiosMockAdapterInstance as mock } from '../axiosInstance';
import mockDataStatusFilter from './data/mock-status-filters-api.json';
import envVariables from "../utils/config.json";

const mockGetStatusFilters = mock
  .onGet(`${process.env.REACT_APP_BASE_URL || envVariables.REACT_APP_BASE_URL}/statusFilter`)
  .reply(function () { return [200, mockDataStatusFilter.statusList] }
  )

export { mockGetStatusFilters }